// extracted by mini-css-extract-plugin
module.exports = {"table":"SubstancesTabPane_table__1kq2F","button":"SubstancesTabPane_button__3v8RH"};